import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useUser } from '../../contexts/UserContext';
import { db } from '../../firebase';
import { collection, onSnapshot } from 'firebase/firestore';
import './Warnings.css';

const Warnings = () => {
    const [warnings, setWarnings] = useState([]);
    const [loadingWarnings, setLoadingWarnings] = useState(true);
    const { userData } = useUser();
    const location = useLocation();

    // Check if current path matches any excluded path pattern
    const shouldHideWarnings = () => {
        const currentPath = location.pathname;
        
        // Check exact match for login
        if (currentPath === '/login') {
            return true;
        }

        // Check if path contains wade-report-mode/month or wade-report-mode/week
        if (currentPath.includes('/wade-report-mode/month') || currentPath.includes('/wade-report-mode/week')) {
            return true;
        }

        return false;
    };

    useEffect(() => {
        if (!userData || !userData.isAdmin) {
            setWarnings([]);
            setLoadingWarnings(false);
            return undefined;
        }

        const warningsRef = collection(db, 'admin', 'general', 'warnings');
        const unsubscribe = onSnapshot(
            warningsRef,
            (snapshot) => {
                const warningMessages = snapshot.docs
                    .map((docSnap) => (docSnap.data() || {}).description)
                    .filter((description) => typeof description === 'string' && description.trim().length > 0);
                setWarnings(warningMessages);
                setLoadingWarnings(false);
            },
            (error) => {
                console.error('Error fetching warnings:', error);
                setWarnings([]);
                setLoadingWarnings(false);
            }
        );

        return () => unsubscribe();
    }, [userData]);

    // Don't render if warnings should be hidden or user is not admin
    if (shouldHideWarnings() || !userData || !userData.isAdmin) {
        return null;
    }

    return (
        <div className="warnings-view">
            {loadingWarnings ?
                <div className="warning-item warning-item-loading">
                    Loading warnings...
                </div>
            : (warnings.length > 0 ?
                warnings.map((value, index) => (
                    <div key={index} className="warning-item">
                        {value}
                    </div>
                ))
            : <div className="warning-item warning-item-empty">
                No warnings
            </div>
            )}
        </div>
    );
};

export default Warnings;

